<template>
  <div class="mb-md-4 mb-3">
    <button
      class="d-flex align-center text-body-2 text-ui-kit-text-secondary link font-weight-semi-bold"
      @click="navigateTo('/')"
    >
      <v-icon
        color="ui-kit-icon-secondary"
        class="mr-2"
        size="24"
        icon="ui-icon-arrow-left"
      />
      <span>На главную</span>
    </button>
  </div>
</template>
